import React from "react";

export default function PlainRichtext({ content }) {
  return (
    <div id="plainRichtext">
      <div className="richtext" dangerouslySetInnerHTML={{ __html: content.richtext }} />
    </div>
  );
}
